import { ButtonProps } from "components/parts/Button/Button/styled";
import { StyledPlus } from "components/parts/Button/IconButton/styled";
import React from "react";

import {
  StyledNavigateBefore,
  StyledButtonWrapper,
  StyledEdit,
  StyledExternalLinkOutline,
  StyledIcon,
  StyledManageAccounts,
  StyledText,
  StyledTextWithIconButton,
  StyledImport,
  StyledReport,
  StyledFileExcel,
  StyledUpload,
  StyledCardList,
  StyledMailOutline,
} from "./styled";

export type PresenterProps = {
  iconName: TextWithIconTypes;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  text: string;
  disabled?: boolean;
  type?: React.ComponentProps<"button">["type"];
} & ButtonProps;

export enum TextWithIconTypes {
  Edit = "Edit",
  ExternalLinkOutline = "ExternalLinkOutline",
  ManageAccounts = "ManageAccounts",
  Plus = "Plus",
  NavigateBefore = "NavigateBefore",
  Import = "Import",
  Report = "Report",
  FileExcel = "FileExecel",
  Upload = "Upload",
  CardList = "CardList",
  MailOutline = "MailOutline",
}

const IconPicker = (iconName: TextWithIconTypes) => {
  switch (iconName) {
    case TextWithIconTypes.Edit:
      return <StyledEdit />;
    case TextWithIconTypes.ExternalLinkOutline:
      return <StyledExternalLinkOutline />;
    case TextWithIconTypes.ManageAccounts:
      return <StyledManageAccounts />;
    case TextWithIconTypes.Plus:
      return <StyledPlus />;
    case TextWithIconTypes.NavigateBefore:
      return <StyledNavigateBefore />;
    case TextWithIconTypes.Import:
      return <StyledImport />;
    case TextWithIconTypes.Report:
      return <StyledReport />;
    case TextWithIconTypes.FileExcel:
      return <StyledFileExcel />;
    case TextWithIconTypes.Upload:
      return <StyledUpload />;
    case TextWithIconTypes.CardList:
      return <StyledCardList />;
    case TextWithIconTypes.MailOutline:
      return <StyledMailOutline />;
  }
};

export const TextWithIconButtonPresenter: React.FC<PresenterProps> = ({
  text,
  size,
  variant,
  iconName,
  ...rest
}) => (
  <StyledButtonWrapper>
    <StyledTextWithIconButton size={size} variant={variant} {...rest}>
      <StyledIcon size={size} variant={variant}>
        {IconPicker(iconName)}
      </StyledIcon>
      <StyledText>{text}</StyledText>
    </StyledTextWithIconButton>
  </StyledButtonWrapper>
);

TextWithIconButtonPresenter.defaultProps = {
  text: "サンプル",
  size: "large",
  variant: "primary",
  iconName: TextWithIconTypes.Edit,
};
